// Pure menu rules. A tile carries `policy` (legacy key(s)) and `perm`/`level`/
// `act` (modular). A tab shows iff it has at least one gated tile that shows;
// ungated tiles (policy "") never open a tab on their own. Tabs flagged
// `always` show to everyone.

const isGated = (tile) => [].concat(tile.policy || []).filter(Boolean).length > 0;

export const tileAllowed = (tile, allow) =>
  allow({ perm: tile.perm, level: tile.level, act: tile.act, legacy: tile.policy });

export const visibleTiles = (tiles, allow) => tiles.filter((t) => tileAllowed(t, allow));

export const tabVisible = (tab, allow) =>
  Boolean(tab.always) || tab.modules.some((t) => isGated(t) && tileAllowed(t, allow));

export const visibleTabs = (tabs, allow) => tabs.filter((t) => tabVisible(t, allow));
